import i18n from '../i18n';
import { parseDeviceToken } from './TokenUtil';


const commonInterface = {
    startCode : function() {
        console.log("window.commonInterface.startCode !\n");
    },
    /**
     * UserAgent를 기반으로 현재 실행 환경을 감지합니다.
     * @returns {'ios' | 'android' | 'web'}
     */
    getPlatform() {
      if (navigator.userAgent.includes("vtotpios")) {
        return "ios"
      }
      else if (navigator.userAgent.includes("vtotpand")) {
        return "android"
      } else {
        return "web"
      }
    },
    /**
     * UserAgent를 기반으로 PC/모바일 웹을 구분합니다.
     * @returns {'pc' | 'mobile'}
     */
    getDeviceType() {
      const ua = navigator.userAgent.toLowerCase();
      const mobileKeywords = [
        'iphone', 'ipod', 'android', 'mobile',
        'blackberry', 'windows phone', 'webos', 'opera mini', 'iemobile'
      ];
      const isMobile = mobileKeywords.some(keyword => ua.includes(keyword));
      // iPad는 iOS 13+에서 Mac으로 표시되므로 별도 체크
      const isIPad = ua.includes('ipad') || (ua.includes('macintosh') && 'ontouchend' in document);

      return (isMobile || isIPad) ? 'mobile' : 'pc';
    },
    /**
     * 모바일 웹 여부
     * @returns {boolean}
     */
    isMobile() {
      return this.getDeviceType() === 'mobile';
    },
    /**
     * PC 웹 여부
     * @returns {boolean}
     */
    isPC() {
      return this.getDeviceType() === 'pc';
    },
    /**
     * 네이티브 앱으로 메시지를 전송합니다.
     * @param {string} str - 전송할 데이터( String으로 변환된 데이터 )
     * @param {function} [webFallback] - 웹 환경에서의 대체 동작
     */
    sendNativeMessage(str, webFallback) {
      const platform = this.getPlatform();
      console.log("sendNativeMessage", platform)

      if (platform === 'ios') {
        window.webkit.messageHandlers.bridgeMessageHandler.postMessage(str);
        return true;
      } 
      else if (platform === 'android') {
         window.bridgeMessageHandler.messageHandler(str); 
         return true;       
      }

      if (typeof webFallback === 'function') {
          webFallback(str);
      }
      return false;
    },

    /**
     * Web <==> Native간 Callback Interface 
     * obj.action :(int) 명령의 번호
     * obj.param.title :(string) 네이티브에서 로깅할 명령의 이름
     * obj.param.callback :(string) 네이티브에서 호출할 callback함수의 이름
     * 이렇게 작성된 obj 은 JSON.stringify(obj)으로 String으로 변환하여 네이티브에 전달한다.
     */
    showNativeLog : function(log) {
        var obj = {};
        obj.action = 100;
        var params = {};
        params.msg = log;
        params.title = "Log";
        obj.bridgeParam = params;
        this.sendNativeMessage( JSON.stringify(obj));        
    },
    showNativeToast : function(msg, status, time ) {
        var obj = {};
        obj.action = 101;
        var params = {};
        params.msg = msg;
        params.title = "Toast";
        obj.bridgeParam = params;
        this.sendNativeMessage(JSON.stringify(obj), function() {
            console.log('[Toast]', msg);
        });
    },
    showNativeAlert : function(msg) {
        var obj = {};
        obj.action = 102;
        var params = {};
        params.msg = msg;
        params.title = "Callback Alert";
        params.callback = "alert('Callback Native')";
        obj.bridgeParam = params;
        this.sendNativeMessage( JSON.stringify(obj));        
    },
    /**
     * 네이티브 Callback이 필요한 Add OTP 명령을 전송합니다.
     */
    callbackInitOtpList : function() {
        var obj = {};
        obj.action = 110;
        var params = {};
        params.title = "Initial OTP List";
        params.callback = "commonInterface.completeCallbackInitOtpList";
        obj.bridgeParam = params;
        this.sendNativeMessage( JSON.stringify(obj));        
    },
    /**
     * completeCallbackInitOtpList 대한 네이티브 콜백함수
     */
    completeCallbackInitOtpList : function(jsonString) {
        if (!jsonString || jsonString === 'null') {
            console.log("No OTP data received");
            if (this._onCompleteInitOtpList) this._onCompleteInitOtpList();
            return;
        }
        try{
          const otpList = JSON.parse(jsonString)
          for( let otp of otpList) {
            let aOtp = {
              mAccount: otp.account,
              mIssuer: otp.issuer,
              mName: otp.name,
              mSecret: otp.secret,
              mAlgorithm: otp.algorithm,
              mDigits: otp.digits,
              mPeriod: otp.period,
              mIcon: otp.icon,
            };

            if(this._onCompelteAddOtp){
              this._onCompelteAddOtp(aOtp);
            }
          }
          console.log(`OTP ${otpList.length} inserted Success!`)
          if (this._onCompleteInitOtpList) this._onCompleteInitOtpList();

        }catch(e) {
          console.error("Failed to completeCallbackInitOtpList()", e);
        }

    },
     /**
     * 네이티브 Callback이 필요한 Add OTP 명령을 전송합니다.
     */
    callbackAddOtp : function() {
        var obj = {};
        obj.action = 111;
        var params = {};
        params.title = "Add OTP";
        params.callback = "commonInterface.completeCallbackAddOtp";
        obj.bridgeParam = params;
        this.sendNativeMessage( JSON.stringify(obj));        
    },
    /**
     * callbackAddOtp에 대한 네이티브 콜백함수
     */
    completeCallbackAddOtp : function(jsonString) {
        console.log("completeCallbackAddOtp received:", jsonString);

        if (!jsonString || jsonString === 'null') {
            console.log("No OTP data received");
            return;
        }
        try {
            const otpData = JSON.parse(jsonString);
            // Android 키 이름을 React 컴포넌트 키 이름으로 변환
            const inputOtp = {
                mAccount: otpData.account || "",
                mIssuer: otpData.issuer || "",
                mName: otpData.name || otpData.account || "",
                mSecret: otpData.secret || "",
                mAlgorithm: otpData.algorithm || "SHA1",
                mDigits: otpData.digits || "6",
                mPeriod: otpData.period || "30",
                mIcon: otpData.icon || ""
            };
            console.log("Parsed OTP:", inputOtp);

            if (this._onCompelteAddOtp) {
                this._onCompelteAddOtp(inputOtp);
            }
        } catch (e) {
            console.error("Failed to parse OTP data:", e);
        }
    },
    _onCompelteAddOtp: null,
    readyOnCompelteAddOtp: function(callback) {
        this._onCompelteAddOtp = callback;
    },
    _onCompleteInitOtpList: null,
    readyOnCompleteInitOtpList: function(callback) {
        this._onCompleteInitOtpList = callback;
    },
    /**
     * React OTP 객체를 네이티브 키 이름으로 변환
     */
    convertToNativeOtp: function(otp) {
        return {
            account: otp.mAccount,
            issuer: otp.mIssuer,
            name: otp.mName,
            secret: otp.mSecret,
            algorithm: otp.mAlgorithm,
            digits: otp.mDigits,
            period: otp.mPeriod,
            icon: otp.mIcon
        };
    },
    /**
     * React OTP 목록을 네이티브 형식으로 변환 후 업데이트
     */
    updateOtpListFromReact: function(reactOtpList) {
        if (!this.isMobile()) return;
        const nativeList = reactOtpList.map(otp => this.convertToNativeOtp(otp));
        this.updateNativeOtpList(nativeList);
    },
    /**
     * Native OTP 목록 업데이트
     */
    updateNativeOtpList: function(otplist) {
      var obj = {};
      obj.action = 112;
      var params = {};
      params.title = "Update OTP List";
      params.data = JSON.stringify(otplist);
      params.callback = "commonInterface.completeUpdateNativeOtpList";
      obj.bridgeParam = params;
      this.sendNativeMessage(JSON.stringify(obj));
    },
    /**
     * updateNativeOtpList에 대한 네이티브 콜백함수
     */
    completeUpdateNativeOtpList: function(result) {
      // result: "success" 또는 "fail"
      if (result === "success") {
        this.showNativeToast("OTP list saved");
      } else {
        this.showNativeToast("Failed to save OTP list");
      }
    },
    /**
     * 네이티브 로딩 화면을 숨기도록 명령합니다.
     * OTP 목록 초기화 완료 후 호출됩니다.
     */
    hideNativeLoading: function() {
        var obj = {};
        obj.action = 113;
        var params = {};
        params.title = "Hide Loading";
        obj.bridgeParam = params;
        this.sendNativeMessage(JSON.stringify(obj));
    },
    getDeviceToken() {
      var obj = {};
      obj.action = 114;
      var params = {};
      params.title = "Get Device Token";
      params.callback = "commonInterface.completeGetDeviceToken";
      obj.bridgeParam = params;
      this.sendNativeMessage(JSON.stringify(obj));
    },
    completeGetDeviceToken(token) {
      const objInfo = JSON.parse(token);
      if (objInfo && objInfo.deviceToken) {
        localStorage.setItem('deviceToken', objInfo.deviceToken);
        console.log("Saved Device token : ", objInfo.deviceToken);

        // 토큰에서 국가 코드 추출하여 언어 설정
        const parsed = parseDeviceToken();
        if (parsed && parsed.language_code) {
          console.log("언어설정을 ", parsed.language_code, " 으로 설정합니다.");
          i18n.changeLanguage(parsed.language_code);
        }
      }
    },



    /**
     * 선택된 언어 코드를 네이티브에 저장합니다. (Action 115)
     * @param {string} langCode - 'en' | 'ko' | 'ja' | 'es'
     */
    changeLanguage: function(langCode) {
        var obj = {};
        obj.action = 115;
        var params = {};
        params.msg = langCode;
        params.title = "Change Language";
        obj.bridgeParam = params;
        this.sendNativeMessage(JSON.stringify(obj));
    },
    /**
     * 네이티브 앱 데이터를 전체 삭제합니다. (Action 116)
     * @param {function} callback - result("success"|"fail")을 인자로 받는 콜백
     */
    clearAppData: function(callback) {
        var obj = {};
        obj.action = 116;
        var params = {};
        params.title = "Clear App Data";
        params.callback = "commonInterface.completeClearAppData";
        obj.bridgeParam = params;
        this._onCompleteClearAppData = callback;
        this.sendNativeMessage(JSON.stringify(obj), function() {
            // 웹 환경 fallback: 인메모리 상태만 초기화
            if (callback) callback("success");
        });
    },
    /**
     * clearAppData에 대한 네이티브 콜백함수
     */
    completeClearAppData: function(result) {
        if (this._onCompleteClearAppData) {
            this._onCompleteClearAppData(result);
            this._onCompleteClearAppData = null;
        }
    },
    _onCompleteClearAppData: null,


};
commonInterface.startCode();

// Android/iOS에서 호출할 수 있도록 window에 노출
window.commonInterface = commonInterface;
window.commonInterface.getDeviceToken(); // 앱이 로드될 때 디바이스 토큰을 요청하여 언어 설정에 활용

export default commonInterface;